import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import useStateRef from 'react-usestateref';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import Helper from '../Helper';
import { APPLICATION_JSON } from '../../middleware/types';

export const CheckoutHeader = ({profile, targerter, headerLogo}) => {
    const [search, setSearch, searchRef] = useStateRef("");
    const mergeCart = useSelector(state => state.mergeCartReducer)
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const [checkoutShipping, setCheckoutShipping]=useState()
    const [checkoutDelivery, setCheckoutDelivery]=useState()
    const [checkoutBilling, setCheckoutBilling]=useState()
    const popoverRef = useRef(null);
    const [redeem, setRedeem]=useState(false)
    const [redeemShipping, setRedeemShipping]=useState(false)
    const [redeemDelivery, setRedeemDelivery]=useState(false)
    const [showDelivery, setShowDelivery, showDeliveryRef] = useStateRef(true);
    const showDeliveryredux = useSelector(state => state.checkOutHeaderOptions.showDelivery);
    const [profileDetail, setProfileDetail, profileDetailRef] = useStateRef('')
    const location = useLocation();
    var previousUrl = location.state;
   // var prevUrlArr = previousUrl?.split('/');
    // useEffect(()=>{        
    //     setShowDelivery(showDeliveryredux);
    //     console.log('showDeliveryRef...', showDeliveryRef.current);       
    // },[showDeliveryredux])

    useEffect(() => {
        //search = window.location.search
        
        setSearch(window.location.pathname);
        if(searchRef.current && searchRef.current.includes('.jsp')){
            setSearch(searchRef.current.replace('.jsp',''));
        }
        switch(searchRef.current){
            //redeem checkout flow
            case "/voucher/redeem":
                break;
            case "/voucher/shipping":
                setRedeem(true)
                setRedeemShipping(false)
                setRedeemDelivery(false)                
                break;
            case "/voucher/delivery":
                setRedeem(true)
                setRedeemShipping(true)
                setRedeemDelivery(false)
                break;
            case "/voucher/review":
                setRedeem(true)
                setRedeemShipping(true)
                setRedeemDelivery(true)
                break;

            //checkout flow
            case "/checkout/shipping":
                setCheckoutShipping(false)
                setCheckoutDelivery(false)
                setCheckoutBilling(false)                
                break;
            case "/checkout/delivery":
                setCheckoutShipping(true)
                setCheckoutDelivery(false)
                setCheckoutBilling(false)                
                break;
            case "/checkout/billing":
                setCheckoutShipping(true)
                setCheckoutDelivery(true)
                setCheckoutBilling(false)
                break;
            case "/checkout/review":
                setCheckoutShipping(true)
                setCheckoutDelivery(true)
                setCheckoutBilling(true)
                break;
            default:
        }
    }, [])

    useEffect(() => {
        setProfileDetail(profile)
    }, [])

    useEffect(() => {
        if ((window.innerWidth > 991)) {
            setIsPopoverOpen(false);
        }
    }, []);

    const handlePopoverToggle = (event) => {
        event.preventDefault();
        if (window.innerWidth <= 991) {
        setIsPopoverOpen(!isPopoverOpen);
        }
    };
   
    useEffect(() => {
        const handleCloseButtonClick = (event) => {
          if (event.target && event.target.matches('.btn-close')) {
            setIsPopoverOpen(false);
          }
        };
    
        const currentPopover = popoverRef.current;
        if (currentPopover) {
          currentPopover.addEventListener('click', handleCloseButtonClick);
        }
    
        // Clean up event listener on unmount or when content changes
        return () => {
          if (currentPopover) {
            currentPopover.removeEventListener('click', handleCloseButtonClick);
          }
        };
      }, [isPopoverOpen]);
    //   useEffect(()=>{
    //     isAllowedPage()
    //   },[])
    //   const isAllowedPage = async()=>{
    //     console.log('isAllowedPage called...');
    //     console.log('prevUrlArr...}',prevUrlArr && prevUrlArr);
    //     var referer = prevUrlArr && prevUrlArr[2];
    //     console.log('referer..?',referer && referer);
    //     var currentPageArr = searchRef.current && searchRef.current.split('/');
    //     var currentPage = currentPageArr && currentPageArr[2];
    //     console.log('currentPageArr...}',currentPageArr && currentPageArr);
    //     console.log('currentUrl..?',currentPage && currentPage);
    //     var actionUrl='';
    //     if(currentPage && referer){
    //          actionUrl = "api/rest/cb/checkout/is-allowed/"+currentPage+'/'+referer;
    //     }       
    //     console.log('actionUrl...',actionUrl && actionUrl);
    //     var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
    //     var res = await Helper.fetchCallFunction(Url, "GET", false, APPLICATION_JSON, '');
    //     if (res.response != null) {
    //         console.log('res.response',res.response);
    //     }else{
    //         console.log('res.response',res.response);
    //     }
    // }

    return (
        // <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content c-shop-list-detail`} >
        
        <div className="c-container">

            <header>
                <div className="row pb-1 mt-1 mt-lg-4">
                    <div className="col-6 logo">
                        <Link to={searchRef.current.includes('/voucher')?"/":"/checkout/cart"}>
                            <img fetchpriority="high" className="logo-header" src={headerLogo ? headerLogo : `/vaststatic/deployed-assets/CbSite/logo.svg`} alt="Carolina Biological Supply" />
                        </Link>
                    </div>

                    <div className="col-6 checkout-utility-nav">
                        <ul className="row list-group list-group-horizontal c-utility-nav float-end">
                            <li className={`text-center list-group-item ${isPopoverOpen ? 'contact' : ''} popover__wrapper popover-service-support`}>
                                <Link className='link-icon-style' onClick={handlePopoverToggle} ><i className="bi bi-chat text-center"></i>
                                <span>Service & Support</span>
                                </Link>
                                {/* <div className={`checkout-header ${isPopoverOpen ? 'open' : ''}`}
                                dangerouslySetInnerHTML={{ __html: targerter ? targerter :''}} ref={popoverRef} >
                                </div> */}

                                <div className='d-lg-block d-none checkout-header'>
                                    <div dangerouslySetInnerHTML={{ __html: targerter ? targerter :'' }}></div>
                                </div>
                                <div className={`d-lg-none d-block checkout-header `} > 
                                    <div className={`c-utility-nav-content checkout-service-support  ${isPopoverOpen ? 'open' : ''}`} dangerouslySetInnerHTML={{ __html: targerter}} ref={popoverRef}></div>
                                </div>
                                    
                               
                            </li>

                        </ul>
                    </div>
                </div>
                {search === "/checkout/save" || search === "/checkout/int/save" ? "" : search.includes("/voucher/redeem") ||
                    search.includes("/voucher/shipping") || search.includes("/voucher/billing") || search.includes("/voucher/review") || search.includes("/voucher/delivery") ?
                    <>{showDeliveryredux && showDeliveryredux ?
                    <nav>
                        <ul className="row g-0 list-unstyled checkout-step">
                            <li className={`col ${search.includes("/voucher/redeem") ? "active" : ""} `} ><span> {redeem ? <Link to="/voucher/redeem">1. Redeem</Link> : "1. Redeem"}</span></li>
                            <li className={`col ${search.includes("/voucher/shipping") ? "active" : ""} `} ><span>{redeemShipping ? <Link to="/voucher/shipping">2. Shipping</Link> : "2. Shipping"}</span></li>
                            <li className={`col ${search.includes("/voucher/delivery") ? "active" : ""} `} ><span>{redeemDelivery ? <Link to="/voucher/delivery">3. Delivery</Link> : "3. Delivery"}</span></li>
                            <li className={`col ${search.includes("/voucher/review") ? "active" : ""} `} ><span>4. Review &amp; Submit</span></li>
                        </ul>
                    </nav> :
                        <nav>
                        <ul className="row g-0 list-unstyled checkout-step">
                            <li className={`col ${search.includes("/voucher/redeem") ? "active" : ""} `} ><span> {redeem ? <Link to="/voucher/redeem">1. Redeem</Link> : "1. Redeem"}</span></li>
                            <li className={`col ${search.includes("/voucher/shipping") ? "active" : ""} `} ><span>{redeemShipping ? <Link to="/voucher/shipping">2. Shipping</Link> : "2. Shipping"}</span></li>
                            <li className={`col ${search.includes("/voucher/review") ? "active" : ""} `} ><span>3. Review &amp; Submit</span></li>
                        </ul>
                    </nav>
                    }</>:
                    <nav>
                        <ul className={`row g-0 list-unstyled checkout-step ${search === "/checkout/register" ?  'mb-0' : '' }`}>
                            <li className={`col ${search.includes("/checkout/shipping") ? "active" : search.includes("/checkout/addressBook") ? "active" : search.includes("/checkout/addAddress") ? "active" : "" } `}><span>{checkoutShipping ? <Link to="/checkout/shipping">1. Shipping</Link> : "1. Shipping"}</span></li>
                            <li className={`col ${search.includes("/checkout/delivery") ? "active" : ""} `}><span>{checkoutDelivery ? <Link to="/checkout/delivery">2. Delivery</Link> : "2. Delivery"}</span></li>
                            <li className={`col ${search.includes("/checkout/billing") ? "active" : ""} `}><span>{checkoutBilling ? <Link to="/checkout/billing">3. Billing</Link> : "3. Billing"}</span></li>
                            <li className={`col ${search.includes("/checkout/review") ? "active" : ""} `}><span>4. Review &amp; Submit</span></li>
                        </ul>
                    </nav>
                }
            </header>
        </div>
        //  </div>
    )
}
